var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.377H9.40625C9.92803 13.914 10.4187 13.4171 10.875 12.8895C12.5938 10.9207 13.5 8.83945 13.5 6.87695C13.5 5.41826 12.9205 4.01932 11.8891 2.98787C10.8576 1.95642 9.45869 1.37695 8 1.37695C6.54131 1.37695 5.14236 1.95642 4.11091 2.98787C3.07946 4.01932 2.5 5.41826 2.5 6.87695C2.5 8.83945 3.40625 10.9207 5.125 12.8895C5.58132 13.4171 6.07197 13.914 6.59375 14.377H3.5C3.36739 14.377 3.24021 14.4296 3.14645 14.5234C3.05268 14.6172 3 14.7443 3 14.877C3 15.0096 3.05268 15.1367 3.14645 15.2305C3.24021 15.3243 3.36739 15.377 3.5 15.377H12.5C12.6326 15.377 12.7598 15.3243 12.8536 15.2305C12.9473 15.1367 13 15.0096 13 14.877C13 14.7443 12.9473 14.6172 12.8536 14.5234C12.7598 14.4296 12.6326 14.377 12.5 14.377ZM8 4.87695C8.39556 4.87695 8.78224 4.99425 9.11114 5.21401C9.44004 5.43378 9.69638 5.74613 9.84776 6.11159C9.99913 6.47704 10.0387 6.87917 9.96157 7.26713C9.8844 7.6551 9.69392 8.01146 9.41421 8.29117C9.13451 8.57087 8.77814 8.76135 8.39018 8.83852C8.00222 8.91569 7.60009 8.87609 7.23463 8.72471C6.86918 8.57334 6.55682 8.31699 6.33706 7.98809C6.1173 7.65919 6 7.27252 6 6.87695C6 6.34652 6.21071 5.83781 6.58579 5.46274C6.96086 5.08767 7.46957 4.87695 8 4.87695Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.49614905f8f48626e7daa151ed03858b.svg";
export { ForwardRef as ReactComponent };